<template>
  <div class="examine">
    <Head></Head>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="dqwz">当前位置：</el-breadcrumb-item>

      <el-breadcrumb-item :to="{ path: '/my' }">个人中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/my?active=我的报名' }"
        >我的报名</el-breadcrumb-item
      >
      <el-breadcrumb-item class="zpgg">审核查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="tac">
      <Process></Process>
      <!-- 右边内容 -->
      <el-col :span="18" class="conter">
        <h2>
          {{info.news_release.name}}
        </h2>
        <div class="wait" v-show="show1">
          <p>报名成功后1-3个工作日内完成审核</p>
          <p>已报名成功审核中！</p>
          <button @click="back()">返回</button>
        </div>
        <div class="success" v-show="show2">
          <p>
            <span>{{ name }}</span
            >，您好，您报名的({{info.post_release.name}})岗位，
          </p>
          <p>已通过审核!</p>
          <p>请打印报名表。</p>
          <div>
            <button @click="toPrint">打印</button>
            <button @click="back">返回</button>
          </div>
        </div>
        <div class="fail" v-show="show3">
          <p>
            <span>{{ name }}</span> ,您好，您报名的({{info.post_release.name}})岗位，
          </p>
          <p>未通过审核!</p>
          <p>
            未通过原因：<span>{{ remark }}</span>
          </p>
          <div>
            <button @click="modify">修改</button>
            <button @click="back()">返回</button>
          </div>
        </div>
      </el-col>
    </el-row>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
import Process from "./Process";
export default {
  props: {},
  data() {
    return {
      name: "",
      //   控制三个状态的显示与隐藏
      show1: false,
      show2: false,
      show3: false,
      remark: "",
      post_id: 0,
      info: {
        news_release:{
          name:"",
        },
        post_release:{
          name:"",
        }
      },
    };
  },
  computed: {},
  created() {
    this.name = localStorage.getItem("real_name");
    var query = this.$route.query;
    this.post_id = query.post_id;
    this.getInfo(this.post_id, 101);},
  mounted() {
  },
  watch: {},
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    modify() {
      this.$router.push("/enroll?post_id=" + this.post_id + "&isedit=1");
    },
    toPrint() {
      this.$router.push("/enroll_printing?post_id=" + this.post_id);
    },

    getInfo(id, code) {
      let _this = this;
      _this
        .request("/api/post_up_info", { post_id: id, code: code }, "get")
        .then((res) => {
          if (res.data.status == "success") {
            _this.info = res.data.data.info;
            if (res.data.data.info.is_approved == 0) {
              this.show1 = true;
            }
            if (res.data.data.info.is_approved == 1) {
              this.show2 = true;
            }
            if (res.data.data.info.is_approved == 2) {
              this.show3 = true;
              this.remark = res.data.data.info.remark;
            }
          }
        });
    },
  },
  components: {
    Head,
    Footer,
    Process,
  },
};
</script>

<style lang="less" scoped>
.examine {
  .tac {
    .conter {
      h2 {
        font-size: 0.5rem;
        color: #00a0e9;
        text-align: center;
      }
      .wait {
        margin-top: 1rem;
        margin-left: 50%;
        transform: translateX(-50%);
        p:nth-of-type(1) {
          font-size: 0.25rem;
          color: red;
        }
        p:nth-of-type(2) {
          font-size: 0.5rem;
        }
        button {
          width: 2.47rem;
          height: 0.67rem;
          font-size: 0.5rem;
          color: #fff;
          background-color: #00a0e9;
          border-radius: 0.1rem;
          float: right;
          margin-top: 1rem;
        }
      }
      .success {
        margin-top: 1rem;
        margin-left: 50%;
        transform: translateX(-50%);
        p:nth-of-type(1) {
          font-size: 0.42rem;
        }
        p:nth-of-type(2) {
          font-size: 0.5rem;
          color: #1add00;
          margin-left: -1rem;
        }
        p:nth-of-type(3) {
          font-size: 0.42rem;
        }
        div {
          float: right;
          button {
            width: 2.47rem;
            height: 0.67rem;
            font-size: 0.5rem;
            color: #fff;
            background-color: #00a0e9;
            border-radius: 0.1rem;
            margin-top: 1rem;
          }
          button:nth-of-type(1) {
            margin-right: 0.48rem;
          }
        }
      }
      .fail {
        margin-top: 1rem;
        margin-left: 50%;
        transform: translateX(-50%);
        p:nth-of-type(1) {
          font-size: 0.42rem;
        }
        p:nth-of-type(2) {
          font-size: 0.5rem;
          color: red;
          margin-left: -1rem;
        }
        p:nth-of-type(3) {
          font-size: 0.42rem;
        }
        div {
          float: right;
          button {
            width: 2.47rem;
            height: 0.67rem;
            font-size: 0.5rem;
            color: #fff;
            background-color: #00a0e9;
            border-radius: 0.1rem;
            margin-top: 1rem;
          }
          button:nth-of-type(1) {
            margin-right: 0.48rem;
          }
        }
      }
    }
  }
}
</style>
